<template>
    <div>
        <!-- Privacy Policy -->
        <div class="card mb-4">
            <div class="card-title">Privacy Policy</div>
            <div class="card-body">
                <div class="form-group">
                    <label>Link <span class="text-danger">*</span></label>
                    <input type="url" v-model="privacyPolicy.link" class="form-control"
                        placeholder="Enter a valid business privacy policy URL" required />
                </div>

                <div class="form-group">
                    <label>Link text <span class="text-danger">*</span></label>
                    <input type="text" v-model="privacyPolicy.linkText" class="form-control"
                        placeholder="Enter Link text" required />
                </div>
            </div>
        </div>

        <!-- Custom Disclosure -->
        <div class="card">

            <div v-if="customDisclosure.enabled && showDisclosure" class="card-body">
                <div class="form-group">
                    <label>Title <span class="text-danger">*</span></label>
                    <input type="text" v-model="customDisclosure.title" class="form-control"
                        placeholder="Disclosure title" required />
                </div>

                <div class="form-group">
                    <label>Text <span class="text-danger">*</span></label>
                    <textarea v-model="customDisclosure.text" class="form-control"
                        placeholder="Enter a marketing or legal disclaimer" required></textarea>
                </div>
            </div>
        </div>
        <div v-if="errors.length" class="error-list mt-4">
            <p v-for="(err, index) in errors" :key="index" class="text-error">⚠ {{ err }}</p>
        </div>

    </div>
</template>
<script>
import { useSuperLeedForm } from "@/store/SuperLeedForm";

export default {
    name: 'DisclosuresStep',
    computed: {
        store() {
            return useSuperLeedForm();
        },
        privacyPolicy: {
            get() {
                return this.store.MetaLeedDisclosures.privacyPolicy;
            },
            set(value) {
                this.store.MetaLeedDisclosures.privacyPolicy = value;
            },
        },
        customDisclosure: {
            get() {
                return this.store.MetaLeedDisclosures.customDisclosure;
            },
            set(value) {
                this.store.MetaLeedDisclosures.customDisclosure = value;
            },
        },
    },
    data() {
        return {
            showDisclosure: true,
            errors: [],
        };
    },
    methods: {
        validate() {
            this.errors = [];

            if (!this.privacyPolicy.link || this.privacyPolicy.link.trim() === "") {
                this.errors.push("Privacy policy link is required.");
            } else {
                const linkRegex = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/\S*)?$/i;
                if (!linkRegex.test(this.privacyPolicy.link)) {
                    this.errors.push("Privacy policy link must be a valid URL.");
                }
            }

            if (!this.privacyPolicy.linkText || this.privacyPolicy.linkText.trim() === "") {
                this.errors.push("Privacy policy link text is required.");
            }

            if (this.customDisclosure.enabled && this.showDisclosure) {
                if (!this.customDisclosure.title || this.customDisclosure.title.trim() === "") {
                    this.errors.push("Disclosure title is required.");
                }

                if (!this.customDisclosure.text || this.customDisclosure.text.trim() === "") {
                    this.errors.push("Disclosure text is required.");
                }
            }

            return this.errors.length === 0;
        }
    }

};
</script>

<style scoped>
.text-error {
    color: #e53935 !important;
    font-size: 15px;
    margin-top: 6px;
}

.card {
    background-color: #fff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
    margin-bottom: 16px;
}

.card-title {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 16px;
}

.card-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.form-group label {
    font-weight: 500;
    margin-bottom: 4px;
    display: block;
}

.form-control {
    width: 100%;
    padding: 10px 14px;
    border-radius: 8px;
    border: 1px solid #ddd;
    font-size: 14px;
}

.form-control:focus {
    outline: none;
    border-color: #237276;
}

.text-danger {
    color: #ff5252;
}

.d-flex {
    display: flex;
}

.justify-between {
    justify-content: space-between;
}

.align-center {
    align-items: center;
}

.gap-2 {
    gap: 8px;
}

.fw-bold {
    font-weight: 600;
}

.toggle-btn {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
}

/* Switch Style */
.switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 22px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
    background-color: #237276;
    color: #237276;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 34px;
}

.slider:before {
    position: absolute;
    content: '';
    height: 16px;
    width: 16px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
}

input:checked+.slider {
    background-color: #237276;
}

input:checked+.slider:before {
    transform: translateX(18px);
}
</style>
